import React from 'react';
import { StyledCobuyerName } from './customer.style';
import type { CobuyerNameProps } from '../../types/ConsumerProps';

const Cobuyer: React.FC<CobuyerNameProps> = ({ name, onCobuyerClick, onRemove, icon: TrashIcon }) => (
    <>
        <StyledCobuyerName size="xsmall" weight="semibold" data-testid="showroom-header-cobuyer-name" onClick={onCobuyerClick}>
            {name}
        </StyledCobuyerName>
        {TrashIcon && <TrashIcon onClick={onRemove} fill="#FFFFFF" />}
    </>
);

export default Cobuyer;
